import React from "react";
import { SVG } from "../../../assets";

// TODO Broken?
interface LogoProps {
  type: "default" | "white";
  properties?: React.SVGProps<HTMLOrSVGElement>;
}
const Logo = ({ type, properties }: LogoProps) => {
  const Svg = type === "white" ? SVG.LogoWhite : SVG.Logo;
  return <Svg {...properties} />;
};

export default Logo;
